@use '../../../../design-tokens/typography/typography' as *;

@layer design-system {
  .logoPlaceholder {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    background-color: var(--surface-default);
    color: var(--text-default);
    @include typography-v2-body-sm;
    font-weight: 500;
    font-style: normal;
  }

  .iconWrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: var(--surface-neutral);
  }

  .cryptoImage {
    background-color: var(--background-default);
    width: 100%;
    height: 100%;
  }
}
